import { LwApiPM } from "@techniaorg/liteweb-api";
import { waitForIFrameAndModel } from "../src/util";

// Wait until the iframe is loaded
const myframe = document.querySelector("iframe#webviewer") as HTMLIFrameElement;
let LwAPI: LwApiPM | null = null;
const apiReady: Promise<LwApiPM | null> = waitForIFrameAndModel(myframe)
  .then((api) => {
    LwAPI = api;
    return api;
  })
  .catch((e) => {
    console.log("LwAPI could not be initialized: ", e);
    return null;
  });

// Example function for demonstration purposes
function ex_setpmivis(b: boolean) {
  LwAPI?.setPmiVisibility(b);
}

document.getElementById("hidePMI")?.addEventListener("click", async () => {
  await apiReady;
  ex_setpmivis(false);
});

document.getElementById("showPMI")?.addEventListener("click", async () => {
  await apiReady;
  ex_setpmivis(true);
});
